import { getApi, postApi , putApi , deleteApi } from "../api";

export const loginApi = (data) => postApi(`/auth/login`, data);